import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';
import { AdminRoute } from '@/components/guards/AdminRoute';

export const Route = createFileRoute('/diagnostics/leadership')({
  component: () => (
    <AdminRoute>
      <PageStub title="Leadership Effectiveness" description="Leadership assessment" />
    </AdminRoute>
  ),
});
